import dayjs from "dayjs";

export const truncateText = (text, maxLength = 20) => {
  if (text?.length > maxLength) {
    return `${text.substring(0, maxLength - 3)}...`;
  }
  return text;
};

export const getHourMin = (date) => {
  const newDate = new Date(date);
  let hour = newDate.getHours();
  let min = newDate.getMinutes().toString().padStart(2, "0");
  const isAfternoon = hour >= 12;
  hour = isAfternoon ? (hour === 12 ? hour : hour - 12) : hour;
  const ampm = isAfternoon ? "PM" : "AM";
  return `${hour}:${min} ${ampm}`;
};


export function convertTo12HourFormat(time) {
  const newFormateTime = String(time);
  const [hour, minute] = newFormateTime.split(".");
  const hourInt = parseInt(hour, 10); // Added radix parameter
  const period = hourInt >= 12 ? "PM" : "AM";
  const hour12 = hourInt % 12 || 12;
  let formattedMinute = "00";
  if (minute) {
    formattedMinute = String(minute).length === 1 ? `${minute}0` : minute;
  }
  return `${hour12}:${formattedMinute} ${period}`;

}
export const handleKeyPress = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  if (!((
    (charCode >= 48 && charCode <= 57) || // Numbers 0-9
    (charCode >= 96 && charCode <= 105) || // Numpad 0-9
    [8, 9, 37, 39, 46].includes(charCode)
  ) // Backspace, Tab, Left Arrow, Right Arrow, Delete
  )) {
    event.preventDefault();
  }
};
export const handleKeyPressForDecimal = (event) => {
  const charCode = event.which || event.keyCode;
  const key = event.key;

  // Allow: numbers, backspace, tab, delete, arrows
  const allowedKeys = [8, 9, 37, 39, 46];

  // Allow digits (top row and numpad)
  const isDigit = (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105);

  // Allow one dot for decimal (check if already present)
  const isDot = key == '.';
  console.log(isDot, 'isDot');

  const alreadyHasDot = event.target.value.includes('.');

  if (isDigit || allowedKeys.includes(charCode)) {
    return;
  }

  if (isDot && !alreadyHasDot) {
    return;
  }

  event.preventDefault();
};
export function convertWebFormateTime2(inputTime) {
  const inputDateTime = new Date(inputTime);
  const year = inputDateTime.getFullYear().toString().slice(-2); // Get last two digits of the year
  const month = inputDateTime.getMonth() + 1; // Month as a number (1-12)
  const day = inputDateTime.getDate(); // Day as a number
  let hours = inputDateTime.getHours();
  const minutes = inputDateTime.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours %= 12;
  hours = hours || 12; // Convert 0 to 12 for 12-hour format

  // Use template literals for string concatenation
  const formattedTime = `${String(day).padStart(2, "0")}-${String(month).padStart(2, "0")}-${year} ${hours}:${String(minutes).padStart(2, "0")} ${ampm}`;
  return formattedTime;
}


export const getHourMinWithoutAmPm = (date) => {
  const newDate = new Date(date);
  let hour = newDate.getHours();
  let min = newDate.getMinutes().toString().padStart(2, "0");
  return `${hour}.${min}`;
};


export const TimeToDate = (timeString) => {
  const x = String(timeString);
  const [hours, minutes] = x.split(".");
  const time = dayjs()
    .hour(hours)
    .minute(
      minutes ? (String(minutes).length == 1 ? `${minutes}0` : minutes) : 0
    );
  return time;
};

export const getDate2to2 = (date) => {
  let now = new Date();
  if (date) {
    now = new Date(date);
  }
  // Set the time to 2 AM
  now.setHours(0);
  now.setMinutes(0);
  now.setSeconds(0);
  now.setMilliseconds(0);
  // now.setHours(2);
  // now.setMinutes(1);
  // now.setSeconds(0);
  // now.setMilliseconds(0);

  // Calculate the end time (1:59 AM the next day)
  let endTime = new Date(now);
  // endTime.setDate(endTime.getDate() + 1);
  endTime.setHours(23);
  endTime.setMinutes(59);
  endTime.setSeconds(59);
  endTime.setMilliseconds(59);
  // let endTime = new Date(now);
  // endTime.setDate(endTime.getDate() + 1);
  // endTime.setHours(2);
  // endTime.setMinutes(0);
  // endTime.setSeconds(0);
  // endTime.setMilliseconds(0);

  return [
    updateTimeFormate(now.toString()),
    updateTimeFormate(endTime.toString()),
  ];
};export function checkDate(date) {
  const today = dayjs().startOf('day'); // Set to start of today
  let givenDate = dayjs().startOf('day'); // Set to start of given date
  if (date) {
    givenDate = dayjs(date).startOf('day'); // Set to start of given date
  }
  if (givenDate.isSame(today, 'day')) {
    return true
  } else if (givenDate.isSame(today.add(1, 'day'), 'day')) {
    return false
  } else {
    return false
  }
}

export function convertTime(inputTime) {
  const inputDateTime = new Date(inputTime);
  // Format the date
  const year = inputDateTime.getFullYear();
  const month = ("0" + (inputDateTime.getMonth() + 1)).slice(-2);
  const day = ("0" + inputDateTime.getDate()).slice(-2);
  let hours = inputDateTime.getHours();
  const minutes = ("0" + inputDateTime.getMinutes()).slice(-2);
  // Construct the formatted string
  const formattedTime = `${year}-${month}-${day}T${hours}:${minutes}`;
  return formattedTime;
}
export function convertWebFormateTime(inputTime) {

  const inputDateTime = new Date(inputTime);
  const year = inputDateTime.getFullYear();
  const month = ("0" + (inputDateTime.getMonth() + 1)).slice(-2);
  const day = ("0" + inputDateTime.getDate()).slice(-2);
  let hours = inputDateTime.getHours();
  const minutes = ("0" + inputDateTime.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedTime = `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
  return formattedTime;
}
export function convertWebFormateTimeForDiscounts(inputTime) {

  const inputDateTime = new Date(inputTime);
  const year = inputDateTime.getFullYear();
  const month = ("0" + (inputDateTime.getMonth() + 1)).slice(-2);
  const day = ("0" + inputDateTime.getDate()).slice(-2);
  let hours = inputDateTime.getHours();
  const minutes = ("0" + inputDateTime.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  return formattedTime;
}
export function convertWebTime(inputTime) {
  const inputDateTime = new Date(inputTime);
  let hours = inputDateTime.getHours();
  const minutes = ("0" + inputDateTime.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedTime = `${hours}:${minutes} ${ampm}`;
  return formattedTime;
}
export function converWebDate(inputTime) {
  const inputDateTime = new Date(inputTime);
  const day = ("0" + inputDateTime.getDate()).slice(-2);
  const month = ("0" + (inputDateTime.getMonth() + 1)).slice(-2); // Months are zero-indexed
  const year = inputDateTime.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  return formattedDate;
}
 
export const getCurrentTime = () => {
  return dayjs(new Date()).format();
};
export const updateTimeFormate = (date) => {
  return dayjs(date).format();
};

export function convertMinutesToHours(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours} hour(s) and ${remainingMinutes} minute(s)`;
}

export function convertMinutesToFormattedString(minutes) {
  if (minutes > 0) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const hoursStr = hours > 9 ? `${hours}` : `0${hours}`;
    let minutesStr = remainingMinutes == 1 ? remainingMinutes : remainingMinutes;
    minutesStr = minutesStr > 9 ? Math.ceil(minutesStr) : `0${Math.ceil(minutesStr)}`;
    return `${hoursStr}:${minutesStr}`;
  }
  return `00:00`;

}

export function convertToIST(dateString) {
  const isUTC = dateString.endsWith("Z");
  const parsedDate = isUTC ? new Date(dateString) : new Date(dateString + "Z");
  const utcOffset = 5.5;
  const istDate = new Date(parsedDate.getTime() + utcOffset * 60 * 60 * 1000);
  const formattedDate = istDate.toISOString().slice(0, 16) + "Z";
  return formattedDate;
}

 
 
export const formatTimeString = (timeString) => {
  // Split the time string by the decimal point
  const parts = timeString.split(".");
  // If there is only one part after the decimal, add a zero
  if (parts[1] && parts[1].length === 1) {
    return `${parts[0]}.${parts[1]}0`;
  }
  return timeString;
};

 
export const getDate2to2Dashbord = (date) => {
  let now = new Date();
  if (date) {
    now = new Date(date);
  }
  // Set the time to 2 AM
  now.setHours(2);
  now.setMinutes(1);
  now.setSeconds(0);
  now.setMilliseconds(0);

  // Calculate the end time (1:59 AM the next day)
  // Calculate the end time (1:59 AM the next day)
  let endTime = new Date(now);
  endTime.setDate(endTime.getDate() + 1);
  endTime.setHours(2);
  endTime.setMinutes(0);
  endTime.setSeconds(0);
  endTime.setMilliseconds(0);
  return [
    updateTimeFormate(now.toString()),
    updateTimeFormate(endTime.toString()),
  ];
};
 

 


export function convertTimeToDate(timeString) {
  const [time, period] = timeString.split(' ');
  const [hours, minutes] = time.split(':').map(part => parseInt(part, 10));

  let hours24 = hours;
  if (period === 'PM' && hours !== 12) {
    hours24 += 12;
  } else if (period === 'AM' && hours === 12) {
    hours24 = 0;
  }
  const today = new Date();
  today.setHours(hours24, minutes, 0, 0);
  return today;
}
export function formatDateToTime(date) {
  // Get hours and minutes from the date
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Format hours for 12-hour format
  let formattedHours = hours % 12;
  formattedHours = formattedHours === 0 ? 12 : formattedHours; // Handle midnight (0 hours)

  // Determine period (AM/PM)
  const period = hours >= 12 ? 'PM' : 'AM';

  // Format minutes with leading zero if necessary
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  // Construct time string in 12-hour format
  const timeString = `${formattedHours}:${formattedMinutes} ${period}`;

  return timeString;
}


 

 

export const combineDateTime = (date, time) => {
  const dateObj = new Date(date);
  const timeObj = new Date(time);
  const combinedDateTime = new Date(dateObj.setHours(timeObj.getHours(), timeObj.getMinutes(), timeObj.getSeconds()));
  return combinedDateTime;
};

export const getStartAndEndOfMonth = (dateString, fullMouth) => {
  const selectedDate = dateString ? dayjs(dateString) : dayjs();
  const currentDate = dayjs();

  let startOfMonth;

  // If the selected month and year are the same as the current month and year
  if (selectedDate.month() === currentDate.month() && selectedDate.year() === currentDate.year()) {
    startOfMonth = currentDate.hour(0).minute(0).second(0).millisecond(0) // Set startOfMonth to the current date
    // startOfMonth = currentDate.hour(2).minute(1);
  } else {
    startOfMonth = selectedDate.startOf('month').hour(0).minute(0).second(0).millisecond(0) // Set startOfMonth to the first day of the selected month
    // startOfMonth = selectedDate.startOf('month').hour(2).minute(1);// Set startOfMonth to the first day of the selected month
  }

  let endOfMonth = selectedDate.endOf('month').hour(23).minute(59).second(59).millisecond(0)
  // let endOfMonth = selectedDate.endOf('month').hour(2).minute(0)
  // endOfMonth = endOfMonth.add(1, 'day');
  if (fullMouth) {
    return {
      fromDate: dayjs(selectedDate).startOf("month").format(), // Format as dd-mm-yyyy
      tillDate: dayjs(selectedDate).endOf("month").format(), // Format as dd-mm-yyyy
    };
  } else {

    return {
      fromDate: startOfMonth.format(), // Format as dd-mm-yyyy
      tillDate: endOfMonth.format(), // Format as dd-mm-yyyy
    };
  }
};


export const DateChecker = (date) => {
  const dateToCheck = new Date(date);
  const currentDate = new Date();

  // Normalize dates by setting time to 00:00:00 to only compare dates
  const dateToCheckDateOnly = new Date(
    dateToCheck.getUTCFullYear(),
    dateToCheck.getUTCMonth(),
    dateToCheck.getUTCDate()
  );

  const currentDateOnly = new Date(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate()
  );

  if (dateToCheckDateOnly > currentDateOnly) {
    return 'Future'
  } else if (dateToCheckDateOnly < currentDateOnly) {
    return 'Past'
  } else {
    return 'Today'
  }
}



 


export const getActiveDayNames = (startDate, endDate) => {
  const activeDays = new Set();
  let currentDate = startDate;

  while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
    const dayName = currentDate.format('dddd'); // Get day name (e.g., "Monday")
    activeDays.add(dayName);
    currentDate = currentDate.add(1, 'day'); // Move to the next day
  }

  return activeDays // Convert Set to Array of day names
};

export const getButtonState = () => {
  const isWithinRestrictedTime = () => {
    const currentTime = new Date();
    const currentHours = currentTime.getHours();

    // Restricted time: 6:00 PM (18:00) to 5:00 AM (05:00)
    return !(currentHours >= 18 || currentHours < 5); // True if outside restricted time
  };

  const withinRestrictedTime = isWithinRestrictedTime();

  // Calculate the time until the next state change
  const now = new Date();
  const nextCheck = new Date(now);

  let nextStateChange;

  if (withinRestrictedTime) {
    // If currently not restricted, the next state change is at 6:00 PM
    nextCheck.setHours(18, 0, 0, 0);

    // If it's already past 6:00 PM, set for the next day
    if (now.getHours() >= 18) {
      nextCheck.setDate(nextCheck.getDate() + 1);
    }
    nextStateChange = true;
  } else {
    // If restricted, the next state change is at 5:00 AM the next day
    nextCheck.setHours(5, 0, 0, 0);
    nextCheck.setDate(nextCheck.getDate() + 1);
    nextStateChange = false;

  }

  const msUntilNextCheck = nextCheck - now; // Milliseconds until the next state change

  return {
    isButtonEnabled: nextStateChange,
    msUntilNextCheck
  };
};



export const handleKeyPressNoSpecialCharactor = (e) => {
  const allowedKeys = [
    "Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"
  ];

  const isCharAllowed = /^[a-zA-Z0-9 ]$/.test(e.key);
  if (!isCharAllowed && !allowedKeys.includes(e.key)) {
    e.preventDefault(); // block anything not in allowed keys or pattern
  }
};